import MissionCard from './MissionCard';

export default MissionCard; 